import { render, staticRenderFns } from "./PIDPdd.vue?vue&type=template&id=c685ec4c&scoped=true"
import script from "./PIDPdd.vue?vue&type=script&lang=js"
export * from "./PIDPdd.vue?vue&type=script&lang=js"
import style0 from "./PIDPdd.vue?vue&type=style&index=0&id=c685ec4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c685ec4c",
  null
  
)

export default component.exports